// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:768px){.logoFooter img{margin-bottom:32px;margin-top:-35px}}.logoFooter img{max-height:83px;max-width:140px}@media (max-width:767px){.reward-image #b-gold{width:125px!important;min-height:70px;padding:8px 6px 6px;font:9px/11px \"Montserrat Bold\",\"Helvetica Neue\",\"Arial\",sans-serif!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
